import { lightbox } from '../Helper/iFrame';

lightbox('youtube');
